// extracted by mini-css-extract-plugin
export default {"wrapper":"Blog_wrapper__-01OQ","containerTop":"Blog_containerTop__rQOlf","leftLayout":"Blog_leftLayout__HIiFG","rightLayout":"Blog_rightLayout__sv0dr"};